$(function () {

    $('.vertical-collection-slider').each(function () {

        const section = $(this);
        const main = section.find('.mainSlider');
        const thumbs = section.find('.thumbSlider');

        const galleryMain = section.find('.gallery-main');
        const gallery = section.find('.vertical-gallery');
        const galleryThumbs = section.find('.gallery-thumbs');


        /* ==========================================
           MAIN SLIDER
        ========================================== */

        if (!main.hasClass('slick-initialized')) {

            main.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                infinite: true
            });

        }


        /* ==========================================
           GALLERY HEIGHT
        ========================================== */

        function updateGalleryHeight() {

            const slickList = main.find('.slick-list');

            if (!slickList.length) return;

            const mainHeight = slickList.outerHeight();

            if (!mainHeight || mainHeight <= 0) return;

            galleryMain.css('height', mainHeight + 'px');
            gallery.css('height', mainHeight + 'px');
            galleryThumbs.css('height', mainHeight + 'px');

        }


        /* ==========================================
           THUMBNAIL MARQUEE
        ========================================== */

        let marqueeAnimation;
        let marqueePosition = 0;
        let lastTime = null;
        let originalHeight = 0;
        let isPaused = false;


        function setupThumbnailMarquee() {

            if (!thumbs.length) return;

            // Prevent duplicate setup
            if (thumbs.data('marquee-ready')) return;

            thumbs.data('marquee-ready', true);


            /* ----------------------------------------
               Add index to original thumbnails
            ---------------------------------------- */

            thumbs.find('.thumb-slide').each(function (index) {

                $(this).attr('data-index', index);

            });


            /* ----------------------------------------
               Save original thumbnails
            ---------------------------------------- */

            const originalSlides = thumbs
                .children('.thumb-slide')
                .clone(true, true);


            /* ----------------------------------------
               Create marquee track
            ---------------------------------------- */

            const track = $('<div class="thumb-marquee-track"></div>');


            /* ----------------------------------------
               Move original thumbnails into track
            ---------------------------------------- */

            thumbs.children('.thumb-slide').appendTo(track);


            /* ----------------------------------------
               Add duplicated thumbnails
            ---------------------------------------- */

            originalSlides.appendTo(track);


            /* ----------------------------------------
               Add track to thumbnail container
            ---------------------------------------- */

            thumbs.append(track);


            /* ----------------------------------------
               Calculate original height
            ---------------------------------------- */

            function calculateMarqueeHeight() {

                if (!track[0]) return;

                originalHeight =
                    track[0].scrollHeight / 2;

            }


            calculateMarqueeHeight();


            /* ----------------------------------------
               Animation
            ---------------------------------------- */

            function animate(time) {

                if (!lastTime) {
                    lastTime = time;
                }

                const delta = time - lastTime;

                lastTime = time;


                if (!isPaused && originalHeight > 0) {

                    /*
                     * Desktop speed
                     */
                    let speed = 100;


                    /*
                     * Slightly slower on mobile
                     * so it is easier to use.
                     */
                    if (window.innerWidth <= 767) {
                        speed = 60;
                    }


                    marqueePosition -=
                        (speed * delta) / 1000;


                    /* --------------------------------
                       Seamless reset
                    -------------------------------- */

                    if (marqueePosition <= -originalHeight) {

                        marqueePosition += originalHeight;

                    }


                    track[0].style.transform =
                        `translate3d(0, ${marqueePosition}px, 0)`;

                }


                marqueeAnimation =
                    requestAnimationFrame(animate);

            }


            marqueeAnimation =
                requestAnimationFrame(animate);


            /* ----------------------------------------
               Desktop mouse pause
            ---------------------------------------- */

            thumbs.on('mouseenter.marquee', function () {

                isPaused = true;

            });


            thumbs.on('mouseleave.marquee', function () {

                isPaused = false;

                lastTime = null;

            });


            /* ----------------------------------------
               Mobile touch support
            ---------------------------------------- */

            thumbs.on('touchstart.marquee', function () {

                isPaused = true;

            });


            thumbs.on('touchend.marquee touchcancel.marquee', function () {

                isPaused = false;

                lastTime = null;

            });


            /* ----------------------------------------
               Recalculate after images load
            ---------------------------------------- */

            $(window).on('load.marquee', function () {

                setTimeout(function () {

                    calculateMarqueeHeight();

                }, 100);

            });


            /* ----------------------------------------
               Recalculate on resize
            ---------------------------------------- */

            $(window).on('resize.marquee', function () {

                setTimeout(function () {

                    calculateMarqueeHeight();

                }, 100);

            });

        }


        /* ==========================================
           START MARQUEE
        ========================================== */

        setTimeout(function () {

            setupThumbnailMarquee();

        }, 200);


        /* ==========================================
           THUMBNAIL CLICK
        ========================================== */

        thumbs.on(
            'click',
            '.thumb-slide',
            function (e) {

                e.preventDefault();
                e.stopPropagation();


                const clickedThumb = $(this);


                const index =
                    clickedThumb.attr('data-index');


                if (index === undefined) return;


                /* ------------------------------------
                   Remove previous clicked border
                ------------------------------------ */

                thumbs
                    .find('.thumb-slide')
                    .removeClass('is-clicked');


                /* ------------------------------------
                   Add border to clicked thumbnail
                ------------------------------------ */

                clickedThumb
                    .addClass('is-clicked');


                /* ------------------------------------
                   Change main slider
                ------------------------------------ */

                main.slick(
                    'slickGoTo',
                    parseInt(index, 10)
                );

            }
        );


        /* ==========================================
           MAIN SLIDER CHANGE
        ========================================== */

        main.on(
            'afterChange',
            function (event, slick, currentSlide) {

                /*
                 * Border intentionally does not
                 * change automatically.
                 */

            }
        );


        /* ==========================================
           INITIAL HEIGHT
        ========================================== */

        setTimeout(function () {

            updateGalleryHeight();

        }, 100);


        setTimeout(function () {

            updateGalleryHeight();

        }, 500);


        /* ==========================================
           WINDOW LOAD / RESIZE
        ========================================== */

        $(window).on('load resize', function () {

            setTimeout(function () {

                updateGalleryHeight();

            }, 100);

        });

    });

});